import { useHelmetTitle } from '@hooks';

import { Helmet } from '@components';

export const AdminSectionOrganizationsPage = () => {
  const { makeTitle } = useHelmetTitle();

  return (
    <>
      <Helmet
        title={makeTitle('Organizations', 'Admin Settings')}
        description="Manage organizations"
      />
      <div className="flex flex-col gap-8">Organizations</div>
    </>
  );
};
